import { useMemo, useState } from "react";
import { CampoNumero, CampoSelect, Pestanas, Resultado, Dato, Rejilla, mxn } from "../components/campos.jsx";
import { calcularIva } from "../lib/calc.js";
import { TASAS_IVA } from "../data/fiscal.js";

export default function Iva() {
  const [monto, setMonto] = useState(1000);
  const [tasa, setTasa] = useState("16");
  const [personalizada, setPersonalizada] = useState(16);
  const [modo, setModo] = useState("agregar");

  const tasaEfectiva = tasa === "custom" ? personalizada : Number(tasa);
  const r = useMemo(() => calcularIva(monto, tasaEfectiva, modo), [monto, tasaEfectiva, modo]);

  return (
    <div className="space-y-6">
      <Pestanas
        valor={modo}
        onChange={setModo}
        opciones={[
          { valor: "agregar", etiqueta: "Agregar IVA" },
          { valor: "desglosar", etiqueta: "Desglosar / quitar IVA" },
        ]}
      />

      <Rejilla>
        <div className="space-y-4">
          <CampoNumero
            label={modo === "agregar" ? "Subtotal, sin IVA ($)" : "Precio final, con IVA incluido ($)"}
            valor={monto}
            onChange={setMonto}
            prefijo="$"
            min={0}
          />

          <CampoSelect
            label="Región / tasa de IVA"
            valor={tasa}
            onChange={setTasa}
            opciones={[
              ...TASAS_IVA.map((t) => ({ valor: String(t.valor), etiqueta: t.etiqueta })),
              { valor: "custom", etiqueta: "Otra tasa…" },
            ]}
          />

          {tasa === "custom" && (
            <CampoNumero label="Tasa personalizada" valor={personalizada} onChange={setPersonalizada} sufijo="%" min={0} max={100} />
          )}
        </div>

        <div className="order-first space-y-3 lg:order-last lg:col-span-2">
          <Resultado
            label={modo === "agregar" ? "Total a pagar con IVA" : "Subtotal sin IVA"}
            valor={mxn(modo === "agregar" ? r.total : r.subtotal)}
            nota={`IVA aplicado: ${tasaEfectiva}%`}
          />

          <div className="tarjeta">
            <Dato label="Subtotal (base gravable)" valor={mxn(r.subtotal)} />
            <Dato label={`IVA (${tasaEfectiva}%)`} valor={mxn(r.iva)} />
            <Dato label="Total" valor={mxn(r.total)} destacar />
          </div>

          <p className="text-2xs texto-3">
            {modo === "agregar"
              ? `Subtotal × ${tasaEfectiva}% = IVA. Subtotal + IVA = total.`
              : `Total ÷ ${(1 + tasaEfectiva / 100).toFixed(2)} = subtotal. Total − subtotal = IVA.`}
          </p>
        </div>
      </Rejilla>
    </div>
  );
}
